import { SvgIcon } from '@mui/material';
import type { FC } from 'react';
import type { DeviceIconProps } from 'utils/helpers';

const GoeChargerProOutlinedIcon: FC<DeviceIconProps> = ({
  color,
  ...props
}) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 10.5C14.4853 10.5 16.5 12.5147 16.5 15C16.5 17.4853 14.4853 19.5 12 19.5C9.51472 19.5 7.5 17.4853 7.5 15C7.5 12.5147 9.51472 10.5 12 10.5ZM12 12.5C10.6193 12.5 9.5 13.6193 9.5 15C9.5 16.3807 10.6193 17.5 12 17.5C13.3807 17.5 14.5 16.3807 14.5 15C14.5 13.6193 13.3807 12.5 12 12.5Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1C16.4183 1 20 4.58172 20 9V15C20 19.4183 16.4183 23 12 23C7.58172 23 4 19.4183 4 15V9C4 4.58172 7.58172 1 12 1ZM12 3C8.68629 3 6 5.68629 6 9V15C6 18.3137 8.68629 21 12 21C15.3137 21 18 18.3137 18 15V9C18 5.68629 15.3137 3 12 3Z"
      fill={color}
    />
  </SvgIcon>
);

export default GoeChargerProOutlinedIcon;
